<template>
  <div>
    <div class="form-group row mb-2">
      <label class="col-sm-4 lh30 text-lr">
        <i v-if=" Data.data.c_priority==='S'" class="fa fa-asterisk text-danger font10 ml-1"
           aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <el-input-number v-model="value1" :min="Data.data.c_data_type==='Numf'?-Infinity:0"
                         @change="dealData"
                         size="small" label="描述文字"></el-input-number>
        -
        <el-input-number v-model="value2" :min="Data.data.c_data_type==='Numf'?-Infinity:0"
                         @change="dealData"
                         size="small" label="描述文字"></el-input-number>
        {{ Data.data.c_unit }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-number",
  props: [
    'Data'
  ],
  data() {
    return {
      value1: this.Data.data.c_value[0]!==undefined?this.Data.data.c_value[0]:0,
      value2: this.Data.data.c_value[1]!==undefined?this.Data.data.c_value[1]:0,
    }
  },
  created() {
  },
  watch: {},
  methods: {
    dealData(){
      console.log(this.value1,this.value2)
      var list={'start':this.value1,'end':this.value2}
      this.$get_function(this.Data,list)
    },
  }


}
</script>

<style scoped>

</style>
